import type { Requirement } from '../types/requirement.type';
import { BaseModel } from './base.model';

export class RequirementModel extends BaseModel implements Requirement {
  readonly name: string | null;
  readonly orderIndex: number;
  readonly isBasicField: boolean | null = null;

  constructor(data: Requirement) {
    super();

    this.name = data.name;
    this.orderIndex = data.orderIndex;

    if (data.isBasicField) {
      this.isBasicField = data.isBasicField;
    }
  }
}
